module.exports = __webpack_public_path__ + "img/title-01.7b3c1855.svg";